module.exports = __webpack_public_path__ + "img/vertical-color.a8957da9.png";